import React, { useState } from 'react'
import { getAllUserActivitesByUserId } from '../AdminActionCreator.component';
// import clock from '../../images/clock.png'
// import colorclock from '../../images/colorclock.png'
class ActivityLogs extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            activityData: ''
        }
    }
    getData() {
        const { allDetail } = this.props
        getAllUserActivitesByUserId(allDetail.userId, callback => {
            console.log(callback)
            this.setState({ activityData: callback?.data })
        })
    }
    componentDidMount() {
        this.getData()
    }
    
    convertMillisecondsToHMS(milliseconds) {
        const totalSeconds = Math.floor(milliseconds / 1000);
        const hours = Math.floor(totalSeconds / 3600);
        const minutes = Math.floor((totalSeconds % 3600) / 60);
        const seconds = totalSeconds % 60;

        return {
            hours,
            minutes,
            seconds
        };
    }

    handleDate(d){
        if (d !== "" && d !== undefined && d !== null) {
            const date = new Date(d); 
            const day = String(date.getDate()).padStart(2, '0');
            const month = String(date.getMonth() + 1).padStart(2, '0'); 
            const year = date.getFullYear();
    
            return `${day}-${month}-${year}`;
        }
        return null;
    }

    render() {
        return (
            <>
                <div className="activity-logs container-fluid animated fadeIn ">
                    <div className='row'>

                        <div className='col-sm-2 col-xs-12'>
                            {this.state.activityData !== '' && this.state.activityData !== null && this.state.activityData !== undefined  ? this.state.activityData?.map((data, i) => {
                                const isLastEntry = i === this.state.activityData?.length - 1;
                                

                                return (
                                    <>
                                        <div className='activity-circle-activetick' style={{ marginTop: i === 0 ? '30px' : '' }}>
                                            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z" /></svg>
                                        </div>
                                        <h6 className='h6stepper' >{data?.activity.replace("_"," ")}</h6>
                                    

                                        {isLastEntry ? (
                                            <>
                                                <div className='stepperlineinActive'></div>
                                                <div className='activity-circle-inactive'></div>
                                            </>
                                        ) : (

                                            <div className='stepperlineActive'></div>
                                        )}
                                    </>
                                );
                            }) : ""}


                        </div>
                        <div className='col-sm-10 col-xs-12' >

                            {this.state.activityData !== '' && this.state.activityData !== null && this.state.activityData !== undefined  ? this.state.activityData?.map((data, i) => {
                                return (
                                    <>
                                        {/* <h4 style={{ marginTop: i === 0 ? '40px' : '' }}><b>{data.activity}</b></h4> */}
                                        <div className="tableactivity" style={{ height: '220px', overflow: 'auto',marginTop: '80px'  }}>
                                            <div className="Activites-table table-other" style={{ overflow: 'auto' }}>
                                                <table className="table table-hover align-middle text-center">
                                                    <thead>
                                                        <tr className="align-middle">
                                                            <th scope="col" style={{ width: '20%' }} colSpan={1}>Date/Time</th>

                                                            <th scope="col" style={{ width: '60%' }} colSpan={1}>Activity</th>
                                                            <th scope="col" style={{ width: '60%' }} colSpan={1}>Type</th>
                                                            <th scope="col" style={{ width: '20' }} colSpan={1}>Comments</th>
                                                        </tr>
                                                    </thead>
                                                    <tbody>
                                                       
                                                                <tr>
                                                                    <td style={{ width: '20%', whiteSpace: 'break-spaces' }}>{this.handleDate(data?.addedOn) || "-"}</td>

                                                                    <td style={{ width: '60%', whiteSpace: 'break-spaces' }}>{data?.activity || "-"}</td>
                                                                    <td style={{ width: '60%', whiteSpace: 'break-spaces' }}>{data?.type || "-"}</td>
                                                                    <td style={{ width: '20%', whiteSpace: 'break-spaces' }}>{data?.comments || "-"}</td>
                                                                </tr>
                                                            
                                                        {/* <tr>
                                                            <td>{data.comment}</td>
                                                            <td>{data.empId}</td>
                                                            <td>{data.date}</td>
                                                        </tr> */}
                                                    </tbody>
                                                </table>
                                            </div>
                                        </div>
                                        {/* <h6 className='tabletext2'><span className='fa fa-clock-o'></span>&nbsp;&nbsp;{data.diffHours}:{data.diffMinutes}</h6> */}
                                    </>
                                )
                            }) : ""}
                        </div>
                    </div>
                </div>
            </>
        )

    }
}
export default ActivityLogs


